<template>
  <div class="productQuotationApplicationAdd container">
    <div class="searchBox">
      <div>
        <el-button size="mini" class="btn" type="primary" v-show="saveBtnShow" @click="saveQuotationApply">保存</el-button>
        <el-button size="mini" class="btn" type="primary" v-show="submitBtnShow" @click="submitQuotationApply">提交</el-button>
      </div>
      <el-form label-width="120px" ref="applyInfoForm" :model="searchForm" class="topform">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="单据编号">
              <el-input class="handle-input" v-model="searchForm.applyNo" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="类型">
              <el-select v-model="searchForm.applyType" :disabled="true" class="handle-input" style="width:100%">
                <el-option :key="index" v-for="(item,index) in applyTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="创建人">
              <el-input class="handle-input" v-model="searchForm.name" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="创建日期">
              <el-date-picker type="date" v-model="searchForm.createDate" placeholder="选择日期" disabled style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="主题">
              <el-input class="handle-input" v-model="searchForm.subject" clearable placeholder="请输入主题" style="width:100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="产品报价明细" name="first">
        <div class="toolsBox" v-show="applyLineEdit">
          <el-button size="mini" @click="showApplyLineAddDialogFunc()">新增</el-button>
          <el-button size="mini" @click="delSelQuotationApplyLine()">删除</el-button>
        </div>
        <ux-grid ref="applyProductTableDataRef" :data="applyProductTableData" keep-source max-height="450" highlight-current-row show-overflow="tooltip">
          <ux-table-column align="center" type="checkbox" width="80" />
          <ux-table-column align="center" title="操作" width="80" v-show="!disableEditor||searchForm.source!=='SUP'">
            <template v-slot="scope">
              <i class="el-icon-edit-outline" @click="onEdit(scope)"></i>
            </template>
          </ux-table-column>
          <ux-table-column align="center" title="序号" type="index" width="60"></ux-table-column>
          <ux-table-column field="eightBitCode" title="8位码" min-width="120" resizable align="center"></ux-table-column>
          <ux-table-column field="eightBitCodeName" title="8位码名称" min-width="120" resizable align="center"></ux-table-column>
          <ux-table-column field="pickupPoint" title="提货点" min-width="120" resizable align="center"></ux-table-column>
          <ux-table-column field="dcName" title="到货仓库（DC）" min-width="200" resizable align="center"></ux-table-column>
          <ux-table-column field="transportaionMethod" title="运输方式" min-width="120" resizable align="center">
            <template v-slot="scope">
              {{scope.row.transportaionMethod | ic("COMMON",'TRANSPORTAION_METHOD')}}
            </template>
          </ux-table-column>
          <ux-table-column field="temperature" title="温区" min-width="100" resizable align="center">
            <template v-slot="scope">
              {{scope.row.temperature | ic("COMMON",'TEMPERATURE')}}
            </template>
          </ux-table-column>
          <ux-table-column field="effectiveBeginDate" title="产品有效开始日期" min-width="180" resizable align="center">
            <template v-slot="scope">
              {{scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD")}}
            </template>
          </ux-table-column>
          <ux-table-column field="supplierNames" title="入围供应商" min-width="140" resizable align="center"></ux-table-column>
        </ux-grid>
      </el-tab-pane>
    </el-tabs>

    <el-dialog el-dialog title="8位码选择" :visible.sync="dialogVisible" width="80%">
      <el-form :model="materialSearchForm" label-width="120px" inline>
        <el-form-item label="8位码编号:" size="small">
          <el-input v-model="materialSearchForm.eightBitCode" clearable />
        </el-form-item>
        <el-form-item label="8位码名称:" size="small">
          <el-input v-model="materialSearchForm.eightBitCodeName" clearable />
        </el-form-item>
        <el-form-item label="工厂编号:" size="small">
          <el-input v-model="materialSearchForm.plantNo" clearable />
        </el-form-item>
        <el-form-item label="工厂名称:" size="small">
          <el-input v-model="materialSearchForm.plantName" clearable />
        </el-form-item>
        <el-form-item label="供应商编号:" size="small">
          <el-input v-model="materialSearchForm.supplierCode" clearable />
        </el-form-item>
        <el-form-item label="供应商名称:" size="small">
          <el-input v-model="materialSearchForm.supplierName" clearable />
        </el-form-item>
        <el-form-item label="提货点:" size="small">
          <el-input v-model="materialSearchForm.pickupPoint" clearable />
        </el-form-item>
        <el-form-item label="DC:" size="small">
          <el-input v-model="materialSearchForm.dcName" clearable />
        </el-form-item>
        <el-form-item label="温区:" size="small">
          <el-input v-model="materialSearchForm.temperature" clearable />
        </el-form-item>
        <el-form-item label="运输方式:" size="small">
          <el-input v-model="materialSearchForm.transportaionMethod" clearable />
        </el-form-item>
        <el-form-item label=" ">
          <el-button size="mini" type="primary" @click="fatchMaterial()">查询</el-button>
          <el-button size="mini">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="margin-bottom:10px;">
        <el-button size="mini" type="primary" @click="createDetailMateria()">选择</el-button>
      </div>
      <el-table :data="materialList" border highlight-current-row class="dialogIntable" @selection-change="handleSelectionChangeMateria">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip prop="eightBitCode" sortable label="8位码"></el-table-column>
        <el-table-column show-overflow-tooltip prop="eightBitCodeName" sortable label="8位码名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="plantName" sortable label="对应工厂编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierCode" sortable label="供应商编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierName" sortable label="供应商名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="dcName" sortable label="DC"></el-table-column>
        <el-table-column show-overflow-tooltip prop="temperatureI18n" sortable label="温区"></el-table-column>
        <el-table-column show-overflow-tooltip prop="transportaionMethodI18n" sortable label="运输方式"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 到货仓库 -->
    <el-dialog :visible.sync="showSelDcMultipleDialog" append-to-body width="80%">
      <SelDc ref="selectDcMultipleRef" :multipleSelectionFlag="false" @subCallMethod="selectDcMethod"></SelDc>
    </el-dialog>
    <!--入围供应商选择-->
    <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%">
      <SelSupplier ref="supplierSelRef" @subCallMethod="selectSupplierMethod"></SelSupplier>
    </el-dialog>
    <el-dialog title="报价明细" :visible.sync="dialogEditVisible" width="80%" @close="onCancel">
      <el-table min-height="450" :data="tableData" ref="tableDataRef" border highlight-current-row class="table">
        <el-table-column show-overflow-tooltip sortable prop="eightBitCode" label="8位码" min-width="100"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="eightBitCodeName" label="8位码名称" min-width="120"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="pickupPoint" label="提货点" min-width="100"></el-table-column>
        <el-table-column sortable prop="dcName" label="到货仓库（DC）" min-width="200">
          <template slot-scope="scope">
            <el-input @click.native="showSelDcDialogFunc('1',scope.row)" suffix-icon="el-icon-search" v-model="scope.row.dcName">&nbsp;</el-input>
          </template>
        </el-table-column>
        <el-table-column sortable prop="transportaionMethod" label="运输方式" min-width="100">
          <template slot-scope="scope">
            <el-select v-model="scope.row.transportaionMethod" class="handle-input">
              <el-option :key="index" v-for="(item,index) in transportaionMethodList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="temperature" label="温区" min-width="80">
          <template slot-scope="scope">{{scope.row.temperature|ic("COMMON","TEMPERATURE")}}</template>
        </el-table-column>
        <el-table-column sortable prop="effectiveBeginDate" label="产品有效开始日期" min-width="200">
          <template slot-scope="scope">
            <el-date-picker :picker-options="pickerOptions" style="width: 80%" value-format="yyyy-MM-dd" v-model="scope.row.effectiveBeginDate" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column sortable prop="supplierNames" label="入围供应商" min-width="120">
          <template slot-scope="scope">
            <el-input @focus="showSelSupplierFunc(scope.row)" suffix-icon="el-icon-search" v-model="scope.row.supplierNames">&nbsp;</el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-row type="flex" justify="center" style="margin-top:10px;">
        <el-button type="primary" @click="onConfirm">确认</el-button>
        <el-button type="primary" @click="onCancel">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import {
  getQuotationApplyInfo,
  getMaterial,
  createDetail,
  submitApplyInfo,
  updateApplyInfo,
  delSelQuotationApplyPro,
  createApplyInfo
} from "@/api/quoteByProduct.js";
import { changeInit, createChange } from "@/api/base-data/materialPriceData";
import { inputChoiceService } from "@/api/common/input-choice";
import SelDc from "@/components/page/base-data/dc-sel-page";
import SelSupplier from "@/components/page/base-data/carrier-sel-page";
import { fileService } from "@/api/common/file-utils";
import commonFun from "@/utils/commonFun";

let minDate = new Date();
if (minDate.getMonth() >= 10) {
  minDate.setFullYear(minDate.getFullYear() + 1);
  minDate.setMonth(minDate.getMonth() + 1 - 12);
} else {
  minDate.setMonth(minDate.getMonth() + 1);
}
minDate.setDate(1);
export default {
  name: "productQuotationApplicationAdd",
  components: {
    SelSupplier,
    SelDc
  },
  data() {
    return {
      dialogEditVisible: false,
      index: null,
      tableData: [],
      activeName: 'first',
      ttQuotationApplyId: null,
      submitBtnShow: false,
      applyLineEdit: false,
      saveBtnShow: false,
      disableEditor: true,
      showSelDcMultipleDialog: false,
      showSelSupplierDialog: false,
      showUploadFlag: false,
      searchForm: {},
      materialSearchForm: {
        eightBitCode: "",
        eightBitCodeName: "",
        plantName: "",
        supplierCode: "",
        supplierName: "",
        pickupPoint: "",
        dcName: "",
        temperature: "",
        transportaionMethod: ""
      },
      transportaionMethodList: [],
      applyProductTableData: [],
      fileList: [],
      materialList: [],
      applyTypeList: [],
      dialogVisible: false,
      SelectionChangeMateriaObj: [],
      page: {
        size: 10,
        current: 1,
        total: 0
      },
      pickerOptions: {
        defaultValue: minDate,
        disabledDate: function (date) {
          let now = new Date();
          if (now.getMonth() >= 10) {
            now.setFullYear(now.getFullYear() + 1);
            now.setMonth(now.getMonth() + 1 - 12);
          } else {
            now.setMonth(now.getMonth() + 1);
          }
          now.setDate(0);
          return date.getTime() >= now.getTime() ? false : true;
        },
      }
    };
  },
  created() {
    this.applyId = commonFun.convertToArray(this.$route.query.applyId);
    // ;

    this.getInputChoiceValues();
    this.getFiles();
    if (this.ttQuotationApplyId != '') {
      this.initData(this.$route.query.applyId)
    } else {
      this.applyPageInit(this.ttQuotationApplyId)
    }
  },
  methods: {
    // 新增线路编辑
    onEdit(scope) {
      this.dialogEditVisible = true
      this.index = scope.rowIndex
      this.tableData.push(JSON.parse(JSON.stringify(scope.row)))
    },
    onConfirm() {
      console.log('this.tableData[0]', this.tableData[0]);
      this.$refs.applyProductTableDataRef.reloadRow(this.$refs.applyProductTableDataRef.data[this.index], this.tableData[0], null)
      console.log('this.$refs.applyProductTableDataRef.data[this.index]', this.$refs.applyProductTableDataRef.data);
      this.dialogEditVisible = false
      setTimeout(() => {
        this.tableData = []
      }, 500);
    },
    onCancel() {
      this.dialogEditVisible = false
      this.tableData = []
    },
    initData: function (applyId) {
      changeInit(commonFun.convertToArray(applyId)).then(res => {
        this.searchForm = res.quotationApply;
        res.quotationApplyProduct.forEach(item => {
          item.effectiveBeginDate = null;
        })
        this.applyProductTableData = res.quotationApplyProduct;
        if (!!res.quotationApply.ttQuotationApplyId && res.quotationApply.status == "1" && res.quotationApply.source == "MCD") {
          //草稿单据
          this.submitBtnShow = true;
          this.saveBtnShow = true;
          this.applyLineEdit = true;
          this.showUploadFlag = true;
          this.disableEditor = false;
          //如果是线路变更申请单
          if (res.quotationApply.applyType == "2") {
            this.applyLineEdit = false;
          }
        } else if (this.ttQuotationApplyId <= 0) {
          //新增线路申请单MCD
          this.saveBtnShow = true;
          // this.submitBtnShow = true;
          this.disableEditor = false;
        }
        this.$refs.applyProductTableDataRef.reloadData(res.quotationApplyProduct)
      });
    },
    applyPageInit: function (ttQuotationApplyId) {
      console.log("以前的初始化")
      getQuotationApplyInfo(ttQuotationApplyId).then(res => {
        console.log("初始化页面", res);
        this.searchForm = res.quotationApply;
        this.applyProductTableData = res.quotationApplyProduct;
        if (
          !!res.quotationApply.ttQuotationApplyId &&
          res.quotationApply.status == "1" &&
          res.quotationApply.source == "MCD"
        ) {
          //草稿单据
          this.submitBtnShow = true;
          this.saveBtnShow = true;
          this.applyLineEdit = true;
          this.showUploadFlag = true;
          this.disableEditor = false;
          //如果是线路变更申请单
          if (res.quotationApply.applyType == "2") {
            this.applyLineEdit = false;
          }
        } else if (this.ttQuotationApplyId <= 0) {
          //新增线路申请单MCD
          this.saveBtnShow = true;
          this.disableEditor = false;
        }
        this.$refs.applyProductTableDataRef.reloadData(res.quotationApplyProduct)
      });
    },
    //下拉列表数据获取
    getInputChoiceValues: function () {
      let mapObj = {};
      mapObj["TT_QUOTATION_APPLY:PRODUCT_APPLY_TYPE"] = "TT_QUOTATION_APPLY:PRODUCT_APPLY_TYPE";
      mapObj["COMMON:TRANSPORTAION_METHOD"] = "COMMON:TRANSPORTAION_METHOD";
      inputChoiceService.getInputChoiceValues(mapObj).then(res => {
        this.applyTypeList = res["TT_QUOTATION_APPLY:PRODUCT_APPLY_TYPE"];
        this.transportaionMethodList = res["COMMON:TRANSPORTAION_METHOD"];
      });
    },
    showApplyLineAddDialogFunc() {
      this.fatchMaterial();
      this.dialogVisible = true;
    },
    //查询8位码
    fatchMaterial() {
      let that = this;
      let data = {
        eightBitCode: this.materialSearchForm.eightBitCode,
        eightBitCodeName: this.materialSearchForm.eightBitCodeName,
        plantName: this.materialSearchForm.plantName,
        supplierCode: this.materialSearchForm.supplierCode,
        supplierName: this.materialSearchForm.supplierName,
        pickupPoint: this.materialSearchForm.pickupPoint,
        dcName: this.materialSearchForm.dcName,
        temperature: this.materialSearchForm.temperature,
        transportaionMethod: this.materialSearchForm.transportaionMethod,
        pageSize: that.page.size,
        pageNum: that.page.current
      };
      getMaterial(data).then(res => {
        console.log(res);
        that.materialList = res.resultData;
        this.page.total = res.totalCount;
      });
    },
    //选择好 8位码（明细创建）
    createDetailMateria() {
      let that = this;
      let datas = this.SelectionChangeMateriaObj;
      var data = datas.map(function (item) {
        let obj = {
          tmMaterialId: item["tmMaterialId"],
          tmDcId: item["tmDcId"],
          tmPickupId: item["tmPickupId"],
          temperature: item["temperature"],
          eightBitCode: item["eightBitCode"]
        };
        return obj;
      });
      createDetail(that.ttQuotationApplyId, data).then(res => {
        that.dialogVisible = false;
        that.applyPageInit(that.ttQuotationApplyId);
      });
    },
    //保存
    saveQuotationApply() {
      var that = this;
      //先判断DC和入围供应商是否为空
      let applyProductTableData = that.applyProductTableData;
      // for (var i = 0; i < applyProductTableData.length; i++) {
      //   if (
      //     applyProductTableData[i].dcName == null ||
      //     applyProductTableData[i].dcName == ""
      //   ) {
      //     that.$message({ message: "DC为必填", type: "warning" });
      //     return;
      //   }
      //   if (
      //     applyProductTableData[i].supplierNames == null ||
      //     applyProductTableData[i].supplierNames == ""
      //   ) {
      //     that.$message({ message: "入围供应商为必填", type: "warning" });
      //     return;
      //   }
      // }
      let quotationApplyInfo = {};
      quotationApplyInfo.quotationApply = this.searchForm;
      quotationApplyInfo.quotationApplyProduct = this.applyProductTableData;
      quotationApplyInfo.quotationApply.ttQuotationApplyId = this.ttQuotationApplyId;
      createChange(quotationApplyInfo).then(res => {
        if (res.meta.success) {
          that.$message({
            message: this.$t("common.saveSuccess"),
            type: "success"
          });
          this.ttQuotationApplyId = res.data;
          if (that.searchForm.source == 'MCD') {
            that.$router.push({
              path: `/product-quotation-application-add`,
              query: {
                applyId: res.data,
                source: "productFreight",
                applyType: 4
              }
            });
          } else {
            that.$router.push({
              path: `/product-quotation-application-sp-add`,
              query: {
                applyId: res.data,
                source: "productFreight",
                applyType: 4
              }
            });
          }
        }
      });

    },
    //线路报价申请单提交
    submitQuotationApply: function () {
      let _this = this;
      if (!!this.ttQuotationApplyId) {
        //先判断DC和入围供应商是否为空
        let applyProductTableData = _this.applyProductTableData;
        for (var i = 0; i < applyProductTableData.length; i++) {
          if (
            applyProductTableData[i].dcName == null ||
            applyProductTableData[i].dcName == ""
          ) {
            _this.$message({ message: "DC为必填", type: "warning" });
            return;
          }
          if (
            applyProductTableData[i].supplierNames == null ||
            applyProductTableData[i].supplierNames == ""
          ) {
            _this.$message({ message: "入围供应商为必填", type: "warning" });
            return;
          }
        }
        _this.submitBtnShow = false;
        let mapObj = {};
        mapObj["applyId"] = this.ttQuotationApplyId;
        mapObj["confirm"] = 0;
        console.log(mapObj);
        submitApplyInfo(mapObj)
          .then(res => {
            console.log(res);
            if (res.meta.success) {
              _this.$message({
                message: _this.$t("common.saveSuccess"),
                type: "success"
              });
              _this.$router.go(-1);
            } else {
              _this
                .$confirm(res.meta.msg, _this.$t("common.tips"), {
                  confirmButtonText: _this.$t("common.confirm"),
                  cancelButtonText: _this.$t("common.cancel"),
                  type: "warning"
                })
                .then(() => {
                  //用户确认后再次提交
                  mapObj["confirm"] = 1;
                  submitApplyInfo(mapObj)
                    .then(res => {
                      _this.$message({
                        message: _this.$t("common.saveSuccess"),
                        type: "success"
                      });
                      _this.$router.go(-1);
                    })
                    .catch(() => {
                      _this.submitBtnShow = true;
                    });
                })
                .catch(() => {
                  _this.submitBtnShow = true;
                });
            }
          })
          .catch(() => {
            _this.submitBtnShow = true;
          });
      }
    },
    showSelDcDialogFunc: function (method, row) {
      let that = this;
      if (!!row) {
        this.tempRows = row;
      } else {
        this.tempRows = null;
      }
      if ("1" == method) {
        if (!that.disableEditor) {
          //单选
          this.multipleSelectionBl = false;
          this.showSelDcMultipleDialog = true;
        }
      } else {
        this.multipleSelectionBl = true;
        this.showSelDcDialog = true;
      }
    },
    showSelSupplierFunc: function (row) {
      let that = this;
      if (!that.disableEditor) {
        this.showSelSupplierDialog = true;
        if (!!row) {
          this.tempRows2 = row;
        } else {
          this.tempRows2 = null;
        }
      }
    },
    //到货仓库选择
    selectDcMethod: function (dcList) {
      let _this = this;
      if (this.multipleSelectionBl) {
        //多选
        let codes = new Array();
        let dcIds = new Array();
        dcList.forEach(item => {
          dcIds.push(item.tmDcId);
          codes.push(item.dcName);
        });
        _this.applyLineNew.dcName = codes.join(",");
        _this.applyLineNew.dcIds = dcIds;
      } else {
        //单选
        this.tempRows.tmDcId = dcList[0].tmDcId;
        this.tempRows.dcName = dcList[0].dcName;
      }
      this.showSelDcDialog = false;
      this.showSelDcMultipleDialog = false;
    },
    //供应商选择
    selectSupplierMethod: function (supList) {
      let _this = this;
      let codes = new Array();
      let supplierIds = [];
      supList.forEach(item => {
        supplierIds.push(item.tmSupplierId);
        codes.push(item.supplierCode);
      });
      _this.tempRows2.supplierNames = codes.join(",");
      _this.tempRows2.supplierIds = supplierIds;
      // _this.applyData.supplierCodes = codes.join(",");
      // _this.applyData.supplierIds = _this.supplierIds;
      this.showSelSupplierDialog = false;
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => {
      })
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then((res) => {
        //删除成功删除列表数据
        files.splice(index, 1);
      })
    },
    //文件列表数据获取
    getFiles: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.ttQuotationApplyId;
      attachment.tsReckindId = 'QUOTATION_APPLY';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList = fileRes;
      })
    },
    //文件上传
    uploadConfirm: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = '1';
        attachment.tsRecId = this.ttQuotationApplyId;
        attachment.tsReckindId = 'QUOTATION_APPLY';
        fileService.saveFile(attachment).then((saveRes) => {
          _this.getFiles();
        })
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    handleSizeChange(e) {
      this.page.size = e;
      // this.customer_list();
    },
    handleCurrentChange(e) {
      this.page.current = e;
      //  this.customer_list();
    },
    handleSelectionChange(row) {
      console.log(row);
    },
    handleSelectionChangeMateria(val) {
      this.SelectionChangeMateriaObj = val;
      console.log(this.SelectionChangeMateriaObj);
    },
    delSelQuotationApplyLine() {
      var that = this;
      let rows = this.$refs.applyProductTableDataRef.selection;
      if (rows.length == 0) {
        //请选择需要删除的明细
        that.$message({
          message: that.$t("apply.selectDelLine"),
          type: "warning"
        });
      } else {
        let ids = [];
        rows.forEach(item => {
          ids.push(item.ttQuotationApplyProductId);
        });
        delSelQuotationApplyPro(ids).then(res => {
          console.log(res);
          if (res.meta.success) {
            that.$message({
              message: that.$t("common.delSuccess"),
              type: "success"
            });
            //that.applyProductTableData = res.data;
            that.applyPageInit(that.ttQuotationApplyId);
          } else {
            that.$message({
              message: that.$t("common.delError"),
              type: "error"
            });
          }
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
.productQuotationApplicationAdd {
  .toolsBox {
    margin-bottom: 10px;
  }

  .a-link {
    text-decoration: underline;
  }

  .topform {
    margin-top: 20px;
  }
}
</style>
